<div class="el-page">
    <div class="el-title">
        <h3>Set your password</h3>
    </div>
    <form [formGroup]="passwordForm" (ngSubmit)="setPassword()">
        <div class="el-formframe">
            <mat-form-field class="el-inputfield">
                <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="password" placeholder="password"
                    autocomplete="new-password">
                <mat-hint>At least 12 characters, with upper and lower case letters, a digit and a special
                    character</mat-hint>
                <mat-error>Password does not meet the requirements</mat-error>
            </mat-form-field>
            <mat-form-field class="el-inputfield">
                <mat-label>Confirm password</mat-label>
                <input matInput type="password" formControlName="confirmPassword" placeholder="confirm password"
                    autocomplete="new-password">
                <mat-error>Password does not meet the requirements</mat-error>
            </mat-form-field>
            <div class="el-buttonframe">
                <button mat-raised-button color="primary" type="submit" class="el-button"
                    [disabled]="!token">Save</button>
            </div>

            <p class="el-message" [ngClass]="{'el-error-message': passwordForm.errors?.['mismatch']}"
                [hidden]="!passwordForm.errors?.['mismatch']">Passwords do not match
            </p>
            <p class="el-message">{{message}}
            </p>
        </div>
    </form>
</div>
